module.exports = __webpack_public_path__ + "img/programme6.7242ddf8.png";